import { CountCellProps } from '../../types';

const DataTypeCountsCell = ({ _customRowProps, dataTypeLabel }: CountCellProps) => {
  return <div>{dataTypeLabel}</div>;
};

export default DataTypeCountsCell;
